var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticStyle:{"text-align":"center","font-weigth":"100"}},[_vm._v("Reporte estadistico de Docentes")]),_c('br'),_c('e-charts',{ref:"pie",attrs:{"autoresize":"","options":_vm.pie,"auto-resize":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }